import { createRouter, createWebHashHistory } from 'vue-router'
import { isNewVersion } from '@/api/api.js'

const routes = [
	// 头部菜单导航菜单
	{
		path: '/',
		name: 'layOut',
		component: () => import('../views/LayOut.vue'),
		children: [
			// 用户中心
			{
				path: '/',
				name: 'home',
				component:() => import('../views/Home.vue'),
			},
			// 账户信息
			{
				path: 'userInfo',
				name: 'userInfo',
				component:() => import('../views/UserInfo.vue'),
			},
			// 登录日志
			// {
			// 	path: 'userLoginLog',
			// 	name: 'userLoginLog',
			// 	component:() => import('../views/UserLoginLog.vue'),
			// },
			// 通知设置
			{
				path: 'userNotice',
				name: 'userNotice',
				component:() => import('../views/UserNotice.vue'),
			},
			// 优惠卷列表
			{
				path: 'userCoupons',
				name: 'userCoupons',
				component:() => import('../views/UserCoupons.vue'),
			},
			// 域名管理
			{
				path: 'domainList',
				name: 'domainList',
				component:() => import('../views/DomainList.vue'),
			},
			// 域名联系人模板
			{
				path: 'domainContacts',
				name: 'domainContacts',
				component:() => import('../views/DomainContacts.vue'),
			},
			// 新建/修改 域名联系人模板
			{
				path: 'domainContactsAdd',
				name: 'domainContactsAdd',
				component:() => import('../views/DomainContactsAdd.vue'),
			},
			// 域名详情
			{
				path: 'domainDetails',
				name: 'domainDetails',
				component:() => import('../views/DomainDetails.vue'),
			},
			// 物理服务器列表
			{
				path: 'serverList',
				name: 'serverList',
				component:() => import('../views/ServerList.vue'),
			},
			// 物理服务器管理
			{
				path: 'serverManager',
				name: 'serverManager',
				component:() => import('../views/ServerManager.vue'),
			},
			// 云服务器列表
			{
				path: 'cloudList',
				name: 'cloudList',
				component:() => import('../views/CloudList.vue'),
			},
			// 云服务器管理
			{
				path: 'cloudManager',
				name: 'cloudManager',
				component:() => import('../views/CloudManager.vue'),
			},
			// VPS列表
			{
				path: 'vpsList',
				name: 'vpsList',
				component:() => import('../views/VpsList.vue'),
			},
			// VPS管理
			{
				path: 'vpsManager',
				name: 'vpsManager',
				component:() => import('../views/VpsManager.vue'),
			},
			// 物理服务器订单
			{
				path: 'orderServer',
				name: 'orderServer',
				component:() => import('../views/OrderServer.vue'),
			},
			// 物理服务器订单详情
			{
				path: 'orderServerDetails',
				name: 'orderServerDetails',
				component:() => import('../views/OrderServerDetails.vue'),
			},
			// 云服务器订单
			{
				path: 'orderCloud',
				name: 'orderCloud',
				component:() => import('../views/OrderCloud.vue'),
			},
			// 云服务器订单详情
			{
				path: 'orderCloudDetails',
				name: 'orderCloudDetails',
				component:() => import('../views/OrderCloudDetails.vue'),
			},
			// 域名订单
			{
				path: 'orderDomain',
				name: 'orderDomain',
				component:() => import('../views/OrderDomain.vue'),
			},
			// 域名订单详情
			{
				path: 'orderDomainDetails',
				name: 'orderDomainDetails',
				component:() => import('../views/OrderDomainDetails.vue'),
			},
			// ssl订单
			{
				path: 'orderSsl',
				name: 'orderSsl',
				component:() => import('../views/OrderSsl.vue'),
			},
			// ssl订单详情
			{
				path: 'orderSslDetails',
				name: 'orderSslDetails',
				component:() => import('../views/OrderSslDetails.vue'),
			},
			// ssl列表
			{
				path: 'sslList',
				name: 'sslList',
				component:() => import('../views/SslList.vue'),
			},
			// ssl联系人模板
			{
				path: 'sslContacts',
				name: 'sslContacts',
				component:() => import('../views/SslContacts.vue'),
			},
			// ssl联系人模板新建 编辑
			{
				path: 'sslContactsAdd',
				name: 'sslContactsAdd',
				component:() => import('../views/SslContactsAdd.vue'),
			},
			// ssl证书详情
			{
				path: 'sslDetails',
				name: 'sslDetails',
				component:() => import('../views/SslDetails.vue'),
			},
			// cdn列表
			{
				path: 'cdnList',
				name: 'cdnList',
				component:() => import('../views/CdnList.vue'),
			},
			// cdn站点列表
			{
				path: 'cdnSiteList',
				name: 'cdnSiteList',
				component:() => import('../views/CdnSiteList.vue'),
			},
			// cdn站点管理
			{
				path: 'cdnSiteManager',
				name: 'cdnSiteManager',
				component:() => import('../views/CdnSiteManager.vue'),
			},
			// 在线充值
			{
				path: 'balanceRecharge',
				name: 'balanceRecharge',
				component:() => import('../views/BalanceRecharge.vue'),
			},
			// 余额明细
			{
				path: 'balanceDetails',
				name: 'balanceDetails',
				component:() => import('../views/BalanceDetails.vue'),
			},
			// 退款列表
			{
				path: 'balanceRefund',
				name: 'balanceRefund',
				component:() => import('../views/BalanceRefund.vue'),
			},
			// 退款列表详情
			{
				path: 'balanceRefundDetails',
				name: 'balanceRefundDetails',
				component:() => import('../views/BalanceRefundDetails.vue'),
			},
			// 账单列表
			{
				path: 'balanceBill',
				name: 'balanceBill',
				component:() => import('../views/BalanceBill.vue'),
			},
			// 账单详情
			{
				path: 'balanceBillDetails',
				name: 'balanceBillDetails',
				component:() => import('../views/BalanceBillDetails.vue'),
			},
			// 工单列表
			{
				path: 'ticket',
				name: 'ticket',
				component:() => import('../views/Ticket.vue'),
			},
			// 提交工单
			{
				path: 'ticketAdd',
				name: 'ticketAdd',
				component:() => import('../views/TicketAdd.vue'),
			},
			// 工单详情
			{
				path: 'ticketDetails',
				name: 'ticketDetails',
				component:() => import('../views/TicketDetails.vue'),
			},
			// 推介计划
			{
				path: 'aff',
				name: 'aff',
				component:() => import('../views/Aff.vue'),
			},
		],
	}
]

const router = createRouter({
	history: createWebHashHistory(),
	routes
})

// 路由前置守卫
router.beforeEach((to, from, next) => {
	if(!to.name) {
		router.push('/')
	} else {
		next()
	}
	// 判断版本号
	// isNewVersion()
	// next()
	// if (to.name !== 'Login' && !tools.getCookie('Authorization') && to.name !== 'JumpStation') next({ name: 'Login' })
	// else next()
})

export default router
